import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { selectColor } from '../../core';

const Button = styled.a`
  background-color: ${selectColor('primary')};
  border-radius: 12px;
  min-height: 48px;
  color: ${selectColor('white')};
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 48px;
  position: relative;
  text-align: center;
  text-decoration: none;
  outline: 0;
  :focus,
  &.btnFocus {
    background-color: ${selectColor('primary')};
    &::after {
      content: '';
      width: 250px;
      height: 34px;
      border: 1px solid ${selectColor('white')};
      position: absolute;
      left: 2px;
      @media (min-width: 1025px) {
        position: absolute;
      }
    }
  }
  :hover,
  &.btnHover {
    background-color: ${selectColor('primaryDark')};
    cursor: pointer;
  }
  :active,
  &.active {
    font-weight: bold;
    background-color: ${selectColor('gray100')};
  }
  :disabled {
    background-color: ${selectColor('gray25')};
    color: #fff;
  }
`;

function BtnPublish(props) {
  const { text, buttonType, linkRef, dataPanel } = props;
  return (
    <Button href={linkRef} className={buttonType} data-panel={dataPanel}>
      {text}
    </Button>
  );
}

BtnPublish.propTypes = {
  text: PropTypes.string.isRequired,
  linkRef: PropTypes.string.isRequired
};

export { BtnPublish };
